<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <div class="navbar-brand">
          <span class="brand-logo">
            <b-img :src="appLogoImage2" alt="Prophasud Symbol" title="Prophasud Symbol" loading="eager" />
          </span>
          <span class="brand-logo ml-50">
            <b-img :src="appLogoImage" alt="Prophasud Text Logo" title="Prophasud Text Logo" loading="eager" />
          </span>
          <!-- <span class="brand-logo">
            <b-img style="max-width: 130px;"
              :src="appLogoImage2"
              alt="logo"
            />
          </span> -->
          <!-- Text removed to keep logo clean -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { $themeConfig } from '@themeConfig'
// import vSelect from 'vue-select'
// import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    // vSelect
  },
  data() {
    return {
      // selected: { title: 'Square' },
      // selected: "",
      // companies: [
      // ],
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage, appLogoImage2 } = $themeConfig.app
    // const company = localStorage.getItem('company');
    return {
      appName,
      appLogoImage,
      appLogoImage2,
      // company,
    }
  },
  computed: {
    cachedUserdata() {
      return JSON.parse(localStorage.getItem('userData'));
    },
    companies() {
      return this.$store.getters["app-userdata/getCompanies"];
    },
    selected() {
      return this.$store.getters["app-userdata/getCompany"];
    },
  },
  created() {
    // if (!['ROLE_ADMIN', 'ROLE_SUPERVISOR'].includes(this.cachedUserdata.role)) {
    //   this.companies = JSON.parse(localStorage.getItem('companies'));
    //   this.selected = this.companies.find(item => item.companyName == localStorage.getItem('company'));
    // }
  },
  methods: {
    async onCompanyClick(item) {
      if (this.selected.id != item.companyId) {
        console.log("company changed !");
        localStorage.setItem("company", item.companyId);
        await this.$http.post("account/company/" + item.companyId);
        window.location.reload();
      }
      // useJwt.setCurrentCompany(item.companyName);
    }
  }
}
</script>

<style scoped>
/* Override global template cap (36px) for brand logo */
::v-deep .brand-logo img {
  max-width: none !important;
  height: 44px !important;
  width: auto !important;
}
</style>
